import { ResponsiveValue, system } from '@wrisk/styled-system'
import { Property } from 'csstype'

export interface WordWrapProps {
  wordWrap?: ResponsiveValue<Property.WordWrap>
}

export const wordWrap = system({
  wordWrap: true,
})
